export * from './acordeon-item.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/acordeon/acordeon-item/index.ts